export default "__VITE_ASSET__D45$ub39__"